module.exports = __webpack_public_path__ + "img/img-5.47d6ade9.png";